module.exports = __webpack_public_path__ + "static/media/baseMeme11.894ba02b.jpg";